import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastService, UmssFeedbackButtonComponent } from '@umss/shared/ui';

@Component({
  standalone: true,
  imports: [RouterModule, UmssFeedbackButtonComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'corporate';
  readonly feedbackUrl =
    'https://forms.clickup.com/90131860392/f/2ky4e2x8-2353/VIDEAI55BERTREIGPZ';

  constructor(
    private toastService: ToastService,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.toastService.registerContainer(this.vcr);
  }
}
